import React from 'react';
import { Box } from '@common-fe/common-fe';

import { CreateOrganization } from '@/modules/ExpressSetup/ExpressSetupSignUp/CreateOrganization';

const ExpressSetupCreateOrganizationPage = () => {
  return (
    <Box style={{ minHeight: '100vh' }} width="100%">
      <CreateOrganization />
    </Box>
  );
};

export default ExpressSetupCreateOrganizationPage;
